<template>
  <div class="footer uk-background-secondary">
    <div class="segment left">
      <div>Powered by <b>Synago</b></div>
    </div>
    <div class="segment center">
      <div class="uk-visible@s">
        <breadcrumbs />
      </div>
      <div class="uk-text-center uk-hidden@s">
        <button class="uk-button uk-button-secondary icon-button" uk-tooltip="title: Breadcrumbs; offset: 12;"><div class="icon gg-more" /></button>
        <div uk-drop="pos: top-center; mode: click; offset: 10;" class="drop-up">
          <div class="breadcrumbs-dropdown">
            <breadcrumbs />
          </div>
        </div>
      </div>
    </div>
    <div class="segment right">
      <button class="uk-button uk-button-secondary icon-button" uk-tooltip="title: App Version; offset: 12;"><div class="icon gg-info" /></button>
      <div uk-drop="pos: top-center; mode: click; offset: 10;" class="drop-up">
        <div class="info">{{ version }} ({{ buildTime }})</div>
      </div>

      <button class="uk-button uk-button-secondary icon-button" uk-tooltip="title: Reload data; offset: 12;" v-html="$icons.refresh" />
      <div uk-drop="pos: top-center; mode: click; offset: 10; boundary: .segment.right; boundary-align: true;" class="drop-up">
        <div class="reload-options">
          <button class="uk-button uk-button-secondary" @click="reload('full')">Full Page</button>
          <button class="uk-button uk-button-secondary" @click="reload('data')">Data Only</button>
        </div>
      </div>

      <router-link :to="{ name: 'ticket-create' }">
        <button class="uk-button uk-button-secondary icon-button" uk-tooltip="title: Report a bug; offset: 12;"><div class="icon gg-debug" /></button>
      </router-link>

      <button v-if="$store.getters['account/type'] === 'operator'" class="uk-button uk-button-secondary icon-button" uk-tooltip="title: Call Center Toggle; offset: 12;" @click="$parent.split.enabled = !$parent.split.enabled; $event.target.blur();">
        <div class="icon gg-phone" :class="{ active: $parent.split.enabled }" />
      </button>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs.vue'

export default {
  name: 'ComponentFooter',

  components: { Breadcrumbs },

  data() {
    return {
      version: this.$globals.app.version
    }
  },

  computed: {
    buildTime() {
      const timestamp = document.documentElement.dataset.buildTimestamp
      return this.$moment(timestamp).format('YYMMDD')
    }
  },

  methods: {
    reload(type) {
      if (type === 'full') {
        // eslint-disable-next-line no-restricted-globals
        location.reload()
      }

      if (type === 'data') {
        const user = this.$firebase.auth().currentUser
        this.$store.dispatch('reload', user)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  align-items: center;
  height: 40px;

  .segment {
    --ggs: .8;
    color: $colour-light;
    font-size: .8em;
    white-space: nowrap;

    &.left {
      display: flex;
      width: 15%;
      min-width: 100px;
      padding: 0 20px;
      text-align: left;
    }

    &.center {
      width: 70%;

      .breadcrumbs-dropdown {
        padding: 8px;
        background-color: $colour-secondary;
      }
    }

    &.right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 15%;
      min-width: 120px;

      .icon-button {
        width: 40px;
        height: 40px;

        .gg-phone {
          transition: color 500ms ease-in-out;
          color: $colour-light;

          &.active {
            color: $colour-success;
          }
        }
      }

      .info {
        padding: 0 6px;
        background-color: $colour-secondary;
      }

      .reload-options {
        display: flex;
        flex-direction: column;
        width: auto;
      }
    }

    .drop-up {
      z-index: 1100;
      width: auto;
    }
  }
}
</style>
